import React from 'react';
import './NotFound.css';

const NotFound = () => {
    return (
        <div className="not-found text-center">
            <h1 className="display-1 metal-font">404</h1>
            <p className="metal-font fs-4">Not Found</p>
        </div>
    );
};

export default NotFound;